import "../../../styles/index.css";
import "./CarouselCategorias.scss";
import CardCategoria from "../../Cards/CardCategoria/CardCategoria";
import ArmazenamentoIcon from '../../../assets/img/Armazenamento.svg';
import CoolerIcon from '../../../assets/img/Cooler.svg';
import FonteIcon from '../../../assets/img/Fonte.svg';
import GabineteIcon from '../../../assets/img/Gabinete.svg';
import GPUIcon from '../../../assets/img/GPU.svg';
import PlacaMaeIcon from '../../../assets/img/PlacaMae.svg';
import ProcessadorIcon from '../../../assets/img/Processador.svg';
import RAMIcon from '../../../assets/img/RAM.svg';
import Slider from "react-slick";
import useWindowDimensions from "../../../utils/windowSize";


function CarouselCategorias() {

    const categorias =
        [
            { icone: ArmazenamentoIcon, categoria: 'Armazenamentos' },
            { icone: CoolerIcon, categoria: 'Coolers' },
            { icone: FonteIcon, categoria: 'Fontes' },
            { icone: GabineteIcon, categoria: 'Gabinetes' },
            { icone: GPUIcon, categoria: 'Placas de Vídeo' },
            { icone: PlacaMaeIcon, categoria: 'Placas-Mãe' },
            { icone: ProcessadorIcon, categoria: 'Processadores' },
            { icone: RAMIcon, categoria: 'Memórias RAM' }
        ];

    const dimensions = useWindowDimensions();

    const slidesPerPage = Math.floor(dimensions.width * 0.8 / (12 * 16));

    const settings = {
        dots: true,
        infinite: true,
        draggable: true,
        swipe: true,
        swipeToSlide: true,
        speed: 500,
        slidesToShow: slidesPerPage > 8 ? 8 : slidesPerPage,
        slidesToScroll: 1
    };

    return (
        <div className={`carousel-categorias-container`}>
            <h6 className='descricao pb-3'>Compare preços por categoria</h6>
            <div className={`slider-container ${slidesPerPage < 8 ? 'slider-container-with-carousel' : 'slider-container-without-carousel'}`}>
                <Slider {...settings}>
                    {
                        categorias.map((categoria, index) => {
                            return (
                                <div className={`carousel-item`} key={index}>
                                    <div className="card-container">
                                        <CardCategoria icone={categoria.icone} categoria={categoria.categoria} key={index} />
                                    </div>
                                </div>
                            )
                        })
                    }
                </Slider>

            </div>
        </div>
    )
}

export default CarouselCategorias
